// Where a floating menu opened from `anchor` should be mounted.
//
// A modal dialog makes everything outside it inert (Fluxon sets `inert` on every branch beside
// the open dialog, again after each LiveView patch), so a menu portaled to <body> from inside a
// modal draws on top but can't be clicked: clicks land on whatever sits underneath. Inside a
// modal the menu has to live in the dialog's subtree, in a part LiveView leaves alone or the
// next patch removes it. The anchor's closest `phx-update="ignore"` ancestor is both. That
// ancestor may clip its overflow, so menus mounted there must be `position: fixed`.
//
// Returns undefined outside modals, so callers keep mounting at <body>.
export const floatingRootFor = (anchor: Element): HTMLElement | undefined => {
  const dialog = anchor.closest('[aria-modal="true"]');
  const host = anchor.closest<HTMLElement>('[phx-update="ignore"]');
  return dialog && host && dialog.contains(host) ? host : undefined;
};
